import React from "react";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./AdmissionHome.css"; // Import custom CSS

const AdmissionHome = () => {
  const handleButtonClick = (message) => {
    toast.success(message);
  };

  return (
    <>
      <div className="container mt-5 bg-gradient bg-success rounded p-5 mb-5">
        {/* Heading */}
        <h3 className="text-center text-white mb-5">
          Choose from the below options
        </h3>

        <div className="row justify-content-center">
          {/* Button 1 */}
          <div className="col-md-3 mb-3">
            <Link to="/erp/admissions/form">
              <button className="btn btn-common w-100">
                New Admission Form
              </button>
            </Link>
          </div>
          {/* Button 2 */}
          <div className="col-md-3 mb-3">
            <Link to="/erp/admissions/list">
              <button className="btn btn-common w-100">
                Student Addmission List
              </button>
            </Link>
          </div>
          {/* Button 3
          <div className="col-md-3 mb-3">
            <button
              className="btn btn-common w-100"
              onClick={() => handleButtonClick("Button 3 clicked")}
            >
              Final Admitted Students
            </button>
          </div> */}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default AdmissionHome;
